// Web-compatible storage functions
export const setItem = async (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    // console.error('Error saving to localStorage:', error);
    throw error;
  }
};

export const getItem = async (key) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    // console.error('Error reading from localStorage:', error);
    return null;
  }
};

export const removeItem = async (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    // console.error('Error removing from localStorage:', error);
    throw error;
  }
};

export const clearStorage = async () => {
  try {
    localStorage.clear();
    return true;
  } catch (error) {
    // console.error('Error clearing localStorage:', error);
    throw error;
  }
};